const theme = {
	primaryColor: "#002fc0",
};

export default theme;
